import React from 'react'

const DefaultRadioTwelve = ({ getStateValue }) => {

    const getStateData = (e) => {

        const stateDataArray = [];
        document.querySelectorAll('.centerTypeSwitch').forEach((item) => {
            stateDataArray[ item.value ] = item.checked
        })

        const hasAnyChecked = stateDataArray.some(val => val === true);

        if (!hasAnyChecked) {
            e.target.checked = true;
            alert("Please select at least one center type");
            return;
        }

        // console.log(stateDataArray)
        getStateValue(stateDataArray)
    }

   
    return (
        <div className="row">
            <div className="col-lg-6 mb-3">
                <div className="card p-0">
                    <div className="card-header border-bottom bg-base py-16 px-24">
                        <div className="d-flex align-items-center flex-wrap gap-28">
                            <h6 className="text-lg fw-semibold mb-0">Choose Centers Type:</h6>

                            <div className="form-switch switch-primary d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input centerTypeSwitch"
                                    type="checkbox"
                                    role="switch"
                                    id="ownStateType"
                                    value="1"
                                    defaultChecked={true}
                                    onChange={getStateData}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="ownStateType"
                                >
                                    Own
                                </label>
                            </div>
                            <div className="form-switch switch-purple d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input centerTypeSwitch"
                                    type="checkbox"
                                    role="switch"
                                    id="partnershipStateType"
                                    value="2"
                                    defaultChecked={false}
                                    onChange={getStateData}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="partnershipStateType"
                                >
                                    Partnership
                                </label>
                            </div>
                            <div className="form-switch switch-purple d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input centerTypeSwitch"
                                    type="checkbox"
                                    role="switch"
                                    id="franchiseStateType"
                                    value="3"
                                    defaultChecked={false}
                                    onChange={getStateData}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="franchiseStateType"
                                >
                                    Franchise
                                </label>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            {/* <div className="col-lg-6 mb-3">
                <div className="card  p-0">
                    <div className="card-header border-bottom bg-base py-16 px-24">
                        <div className="d-flex align-items-center flex-wrap gap-28">
                            <h6 className="text-lg fw-semibold mb-0">Type of Doctors: </h6>
                            <div className="form-switch switch-primary d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input columnDataType"
                                    type="checkbox"
                                    role="switch"
                                    value="lead"
                                    id="LeadsDataType"
                                    defaultChecked={true}
                                    onChange={getColumnData}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="LeadsDataType"
                                >
                                    By Dr. Bimal Chhajer
                                </label>
                            </div>
                            <div className="form-switch switch-purple d-flex align-items-center gap-3">
                                <input
                                    className="form-check-input columnDataType"
                                    type="checkbox"
                                    role="switch"
                                    value="patient"
                                    id="PatientDataType"
                                    defaultChecked={false}
                                    onChange={getColumnData}
                                />
                                <label
                                    className="form-check-label line-height-1 fw-medium text-secondary-light"
                                    htmlFor="PatientDataType"
                                >
                                    By Assistant Doctors
                                </label>
                            </div>

                        </div>

                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default DefaultRadioTwelve
